// pages/module-pages/reviews/NewReviewPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseReview } from "../../../types/features/Review";
import useReviews from "../../../hooks/features/reviews/useReviews";
import ReviewForm from "../../../components/shared/reviews/ReviewForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";

export default function NewReviewPage() {
  const { createReview } = useReviews();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = async (data: BaseReview) => {
    setIsLoading(true);
    const slug = `${data.user_name.toLowerCase().replace(/\s+/g, "-")}-${data.rating}-etoiles`;
    const success = await createReview({ ...data, slug });
    setIsLoading(false);
    if (success) {
      setIsSuccess(true);
    }
  };

  return (
    <PageLayout title="Nouvelle publication d'avis" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Nouvel avis</h1>
          <p className="text-gray-500 mt-1">Ajoutez un avis depuis le Play Store ou l'App Store</p>
        </div>
        <ReviewForm isSuccess={isSuccess} onSubmit={handleSubmit} isLoading={isLoading} />
      </PageContainer>
    </PageLayout>
  );
}
